import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import Reveal from './Reveal';
import SectionHeader from './SectionHeader';
import EditableText from './EditableText';
import { BTN_OUTLINE, RADIUS_SURFACE } from '../config/brand';

const AgeLevels = ({ levels }) => {

  return (
    <section className="section-y px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <SectionHeader
          eyebrow="Par tranche d'âge"
          eyebrowKey="home.ages.eyebrow"
          title="Un parcours adapté à chaque enfant"
          titleKey="home.ages.title"
          subtitle="De 6 à 16 ans, nos programmes évoluent avec le niveau — du premier robot au code Python et Arduino."
          subtitleKey="home.ages.subtitle"
          reveal
        />

        <div className="grid md:grid-cols-3 gap-8 lg:gap-10">
          {levels.map((level, i) => {
            const n = i + 1;
            return (
              <Reveal key={level.title} animation="fade-up" delay={i * 70}>
                <article className="group flex h-full flex-col">
                  <div className={`relative mb-5 aspect-[16/10] overflow-hidden ${RADIUS_SURFACE} bg-slate-100`}>
                    <img
                      src={level.image}
                      alt={level.title}
                      className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#18449e]/35 via-transparent to-transparent" />
                    <span className="absolute bottom-3 left-3 text-xs font-semibold uppercase tracking-[0.12em] text-white/95">
                      {level.ageRange}
                    </span>
                  </div>

                  <EditableText
                    editKey={`home.ages.${n}.level`}
                    defaultValue={level.level}
                    as="p"
                    className="text-[#3a00e0] text-xs font-semibold uppercase tracking-[0.12em] mb-1.5"
                  />
                  <EditableText
                    editKey={`home.ages.${n}.title`}
                    defaultValue={level.title}
                    as="h3"
                    className="text-slate-900 text-xl font-semibold mb-2 tracking-tight"
                  />
                  <EditableText
                    editKey={`home.ages.${n}.text`}
                    defaultValue={level.description}
                    as="p"
                    multiline
                    className="text-slate-600 text-sm leading-relaxed mb-4"
                  />

                  <ul className="mb-6 space-y-2 flex-1">
                    {level.highlights.map((item, hi) => (
                      <li
                        key={`${level.title}-h-${hi}`}
                        className="flex items-start gap-2.5 text-sm text-slate-600"
                      >
                        <span
                          className="mt-2 h-1 w-1 shrink-0 rounded-full bg-[#3a00e0]"
                          aria-hidden="true"
                        />
                        <EditableText
                          editKey={`home.ages.${n}.highlight.${hi + 1}`}
                          defaultValue={item}
                          as="span"
                          className="text-slate-600 text-sm leading-snug"
                        />
                      </li>
                    ))}
                  </ul>

                  <Link to={level.link} className="mt-auto">
                    <Button variant="outline" className={`w-full ${BTN_OUTLINE}`}>
                      <EditableText editKey={`home.ages.${n}.cta`} defaultValue="En savoir plus" className="inline" />
                      <ArrowRight className="ml-2 h-4 w-4" aria-hidden="true" />
                    </Button>
                  </Link>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AgeLevels;
